import React, { FC } from 'react';
import { Box } from '@mui/material';
import ProductSummaryCard from 'FeatureModules/ProductPage/Components/Tables/ProductSummaryCard';
import { useNavigate } from 'react-router-dom';
import useProductActions from 'FeatureModules/ProductPage/hooks/useProductActions';
import { Plus } from '@styled-icons/bootstrap/Plus';
import { ThemeButton, CardContainer, ActionLink, ItemCardSmall } from 'DesignSystem';
import { IProduct } from 'FeatureModules/ProductPage/types/product.types';
import { useQueryParam, BooleanParam } from 'use-query-params';
import useConfig from 'hooks/useConfig';
import { EBackgroundTypes } from 'DesignSystem/types/background.types';
import { EAvailableSizes } from 'DesignSystem/types/size.types';

interface INextStepLanguageProps {
  publishedProduct: IProduct;
  minHeight?: number;
  handleShowNextCard?: () => void;
}

const NextStepLanguage: FC<INextStepLanguageProps> = ({
  publishedProduct,
  minHeight,
  handleShowNextCard,
}) => {
  const navigate = useNavigate();
  const { goToProductAnalytics, navigateToProductOverview, navigateToProductEditor } =
    useProductActions();
  const { appQueryParams } = useConfig();
  const [, setOpenLanguageDialog] = useQueryParam<boolean | null | undefined>(
    appQueryParams.addLanguage,
    BooleanParam
  );

  const handleAddLanguage = () => {
    navigate(`/products/active/${publishedProduct.id}`);
    setOpenLanguageDialog(true);
  };

  return (
    <CardContainer
      title="Make your product information more accessible and publish in another language"
      background={EBackgroundTypes.WORLD}
      size={EAvailableSizes.MEDIUM}
      minHeight={minHeight}
    >
      <Box mt="auto" pb={2}>
        {publishedProduct && (
          <ItemCardSmall
            onCardClick={() => navigateToProductOverview(publishedProduct.id)}
            onClickEdit={() => navigateToProductEditor(publishedProduct.id)}
            onClickAnalytics={() => goToProductAnalytics(publishedProduct.id)}
          >
            <ProductSummaryCard product={publishedProduct} />
          </ItemCardSmall>
        )}
      </Box>
      <Box display="flex" alignItems="center" gap={2.5}>
        <ThemeButton
          color="PRIMARY"
          size="large"
          startIcon={<Plus size={20} color="white" />}
          onClick={handleAddLanguage}
        >
          Add new language
        </ThemeButton>
        {handleShowNextCard && <ActionLink onClick={handleShowNextCard}>Next tip</ActionLink>}
      </Box>
    </CardContainer>
  );
};

export default NextStepLanguage;
